import Strings from "src/shared/Strings";
class Program {
    constructor(parameters) {
        this.name = Strings.capitalize(parameters.program_label);
        this.program_label = parameters.program_label;
        this.campaigns = parameters.campaigns;
    }
    getCampaigns() {
        return this.campaigns;
    }
    getProgramLabel() {
        return this.program_label;
    }
    getDisplayName() {
        return this.name;
    }
}
export default Program;
